


















































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import { AddressEmployee } from '@/model/addresses/AddressEmployee'
import { GridOptions } from '@/types'
import DeleteDialog from '@/components/DeleteDialog.vue'
import NotesDialog from '@/components/master-data/address/NotesDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { COMPANY_FETCH_COMPANY_STRUCTURE, FETCH_NOTES, FETCH_NOTES_TYPE_LIST, SAVE_NOTE } from '@/store/action-types'
import { COMPANY_GET_BASIC_COMPANY_STRUCTURE } from '@/store/getter-types'
import { Employee } from '@/model/companyStructure/Employee'
import { NoteType } from '@/model/addresses/NoteType'
import { Note } from '@/model/addresses/Note'
import moment from 'moment'
import PrivateCellRenderer from '@/components/cell-renderer/PrivateCellRenderer.vue'
import { NotePayload } from '@/types/payload'
import { AdressenNotizenIndexResponse } from '@/types/service-response'

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  employeeList: Employee[]
  noteTypeList: NoteType[]

  gridData: Note[]
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  overlayNoRowsTemplate: string
  currentSelectedRowId: string
  currentSelectedRowData: Note | undefined
  showDialog: boolean
  showDeleteDialog: boolean
}

export default Vue.extend({
  name: 'Notes',

  components: {
    AgGridVue,
    DeleteDialog,
    NotesDialog
  },

  props: {
    addressId: Number,
    addressEmployee: Array as () => Array<AddressEmployee>
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      employeeList: [],
      noteTypeList: [],

      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.addresses.title'), field: 'noteTitle' },
          { headerName: this.$t('masterData.addresses.person'), field: 'addressEmployee' },
          { headerName: this.$t('masterData.addresses.responsibleName'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const employee: Employee | undefined = this.employeeList.find((item: Employee) => item.id === params.data.responsibleEmployee)
              return employee ? employee.fullName : ''
            }
          },
          { headerName: this.$t('masterData.addresses.noticeTypeDescription'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const noteType: NoteType | undefined = this.noteTypeList.find((item: NoteType) => item.id === params.data.noteType)
              return noteType ? noteType.name : ''
            }
          },
          { headerName: this.$t('masterData.addresses.start'),
            valueGetter: (params: any) => {
              return moment(params.data.dateStartIso, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY")
            }
          },
          { headerName: this.$t('masterData.addresses.due'),
            valueGetter: (params: any) => {
              return moment(params.data.dateEndIso, "DD.MM.YYYY HH:mm:ss").format("DD.MM.YYYY")
            }
          },
          { headerName: this.$t('masterData.addresses.completed'), field: 'alreadyDone' },
          { headerName: this.$t('masterData.addresses.private'), field: 'isPrivate', cellRenderer: 'privateRenderer'},
          { headerName: this.$t('masterData.addresses.description'), field: 'noteText' }
        ]
      },
      gridFrameworkComponents: {
        privateRenderer: PrivateCellRenderer
      },
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      currentSelectedRowId: '',
      currentSelectedRowData: undefined,
      showDialog: false,
      showDeleteDialog: false
    }
  },

  watch: {
    addressId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.currentSelectedRowId = ''
        this.currentSelectedRowData = undefined
        this.fetchData()
        this.fetchNoteTypeList()
        this.fetchNotesData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnableButtons (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id)
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onRowClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedRowData = this.gridData.find((item: Note) => item.id === parseInt(this.currentSelectedRowId))
    },

    onAddNoteClick (): void {
      this.currentSelectedRowData = undefined
      this.showDialog = true
    },

    onEditNoteButtonClick (): void {
      this.showDialog = true
    },

    dialogSaved (): void {
      this.fetchNotesData()
      this.showDialog = false
    },

    closeDialog (): void {
      this.showDialog = false
    },

    onDeleteNoteButtonClick (): void {
      this.showDeleteDialog = true
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
        if(this.currentSelectedRowData && this.currentSelectedRowData.id) {
          const payload: NotePayload = {
            id: this.currentSelectedRowData.id,
            selectedAddressEmployeeId: null,
            selectedAddressEmployeeName: this.currentSelectedRowData.addressEmployee ? this.currentSelectedRowData.addressEmployee : '',
            selectedResponsibleEmployee: this.currentSelectedRowData.responsibleEmployee ? this.currentSelectedRowData.responsibleEmployee : null,
            dateStartIso: this.currentSelectedRowData.dateStartIso,
            dateEndIso: this.currentSelectedRowData.dateEndIso,
            alreadyDone: this.currentSelectedRowData.alreadyDone,
            selectedAuthor: this.currentSelectedRowData.author ? this.currentSelectedRowData.author : null,
            isPrivate: this.currentSelectedRowData.isPrivate,
            noteType: this.currentSelectedRowData.noteType ? this.currentSelectedRowData.noteType : null,
            noteTitle: this.currentSelectedRowData.noteTitle,
            noteText: this.currentSelectedRowData.noteText,
            addressId: this.addressId,
            action: 'Delete'
          }

          this.deleteNote(payload)
        }
    },

    async deleteNote (payload: NotePayload): Promise<void> {
      try {
        let response: AdressenNotizenIndexResponse = await this.$store.dispatch(SAVE_NOTE, payload)
        if(!response.IsError) {
          this.onDeleteDialogClose()
          this.currentSelectedRowId = ''
          this.currentSelectedRowData = undefined
          this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchNotesData()
        } else {
          this.onDeleteDialogClose()
          this.currentSelectedRowId = ''
          this.currentSelectedRowData = undefined
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchNotesData (): Promise<void> {
      this.gridData = await this.$store.dispatch(FETCH_NOTES, this.addressId)
    },

    async fetchNoteTypeList (): Promise<void> {
      this.noteTypeList = await this.$store.dispatch(FETCH_NOTES_TYPE_LIST)
    },

    async fetchData (): Promise<void> {
      await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
      this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList
    }
  },

  mounted () {
    this.fetchData()
    this.fetchNoteTypeList()
    this.fetchNotesData()
  }

})
